export const styles = theme => ({
  card: {
    maxWidth: "480px",
    margin: "0 auto"
  },
  amount_row: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    padding: "10px 0"
  },
  amount_item: {
    display: "inline-flex",
    alignItems: "baseline",
    marginRight: "20px",
    "&:last-child": {
      marginRight: 0
    }
  },
  amount_currency: {
    fontSize: "13px",
    color: "rgba(0, 0, 0, 0.54)",
    marginLeft: "5px"
  },
  amount_value: {
    fontSize: "22px",
    fontWeight: "500"
  },
  approve_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  },
  reject_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  },
  result_icon: {
    fontSize: "72px"
  },
  link_expired_card: {
    maxWidth: "480px",
    margin: "8vh auto 0",
    "@media (max-width: 600px)": {
      margin: "5vh auto 0"
    }
  },
  link_expired_body: {
    padding: "40px 30px 44px"
  },
  link_expired_title: {
    margin: 0,
    fontSize: "26px",
    fontWeight: "500",
    lineHeight: 1.3,
    color: "#3D4051",
    textAlign: "center"
  },
  link_expired_title_text: {
    position: "relative",
    display: "inline-block",
    whiteSpace: "nowrap"
  },
  link_expired_icon: {
    position: "absolute",
    left: "100%",
    top: "50%",
    transform: "translateY(-50%)",
    marginLeft: "8px",
    fontSize: "26px",
    color: "#FFB300"
  },
  link_expired_text: {
    margin: "14px 0 0 0",
    fontSize: "16px",
    color: "rgba(0, 0, 0, 0.64)",
    lineHeight: "1.6"
  },
  wrong_account_body: {
    padding: "40px 40px 30px",
    "@media (max-width: 600px)": {
      padding: "30px 20px 24px"
    }
  },
  wrong_account_avatar: {
    width: "76px",
    height: "76px",
    margin: "0 auto",
    borderRadius: "50%",
    backgroundColor: "#FFCA28",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  wrong_account_icon: {
    fontSize: "40px",
    color: "#FFFFFF"
  },
  wrong_account_title: {
    margin: "24px 0 0 0",
    fontSize: "28px",
    fontWeight: "400",
    lineHeight: 1.4,
    color: "#3D4051",
    "@media (max-width: 600px)": {
      fontSize: "22px"
    }
  },
  wrong_account_text: {
    margin: "16px 0 0 0",
    fontSize: "16px",
    color: "rgba(0, 0, 0, 0.54)",
    lineHeight: "1.6"
  },
  wrong_account_current: {
    margin: "10px 0 0 0",
    fontSize: "15px",
    color: "rgba(0, 0, 0, 0.54)",
    wordBreak: "break-word"
  },
  wrong_account_current_email: {
    fontWeight: "500",
    color: "#3D4051"
  },
  wrong_account_details: {
    margin: "30px 0",
    padding: "0 22px",
    backgroundColor: "#FDF6DC",
    border: "1px solid #F5E3A3",
    borderRadius: "4px",
    textAlign: "left"
  },
  wrong_account_detail: {
    padding: "22px 0",
    "& + &": {
      borderTop: "1px solid #F5E3A3"
    }
  },
  wrong_account_detail_label: {
    fontSize: "15px",
    color: "rgba(0, 0, 0, 0.54)"
  },
  wrong_account_detail_value: {
    marginTop: "6px",
    fontSize: "17px",
    fontWeight: "500",
    color: "#3D4051",
    wordBreak: "break-word"
  },
  wrong_account_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  }
});
